import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi"
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {}
      }
    }
  }
});
